import script from "./AdminPrayerRequestInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPrayerRequestInfo.vue?vue&type=script&setup=true&lang=js"

import "./AdminPrayerRequestInfo.vue?vue&type=style&index=0&id=58e959eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58e959eb"]])

export default __exports__